<div class="card__container" (click)="expandirCardMobile()">
  <div
    class="card__experiencia__resgatada"
    [ngClass]="{ espacamento: onClickExpandir }"
  >
    <div class="header__area">
      <div class="experiencia__imagem">
        <img
          class="imagem"
          [ngClass]="{ 'ajust--image': onClickExpandir }"
          [src]="imagemSrc"
        />
        <div class="button__expandir" *ngIf="windowWidth <= 999">
          <button class="button">
            <img class="img__expandir" [src]="iconeExpandirSrc()" alt="" />
          </button>
        </div>
      </div>

      <div class="experiencia__detalhes">
        <div class="experiencia__header">
          <div class="experiencia__header__itens">
            <p
              class="status__resgate"
              [ngClass]="{
                'momento--estornado': ehEstornada,
                'momento--expirado':
                  (experienciaExpirada && !ehEstornada) ||
                  (experienciaExpiradaParceiro && !ehEstornada),
                'beneficio--expirado':
                  (experienciaExpirada && tipo == 3) ||
                  (experienciaExpiradaParceiro && tipo == 3),
                'momento--utilizado':
                  experiencia.quantidadeDisponivel == 0 && !ehEstornada,
                'momento--disponivel':
                  experiencia.quantidadeDisponivel > 0 &&
                  (!experienciaExpirada || experienciaExpiradaParceiro)
              }"
              *ngIf="
                (statusBeneficioEexpirado ||
                  statusExpirado ||
                  statusEstornado ||
                  statusUtilizado ||
                  statusDisponivel) &&
                experiencia.parceiro.nome.includes('Cacau Show') &&
                !parceiroViva
              "
            >
              <img
                class="icon__status"
                [src]="this.iconeStatus"
                alt="Ícone do status"
              />
              {{ textoStatus }}
            </p>
            <p
              class="status__resgate"
              [ngClass]="{
                'momento--estornado': ehEstornada,
                'momento--expirado':
                  (experienciaExpirada && !ehEstornada) ||
                  (experienciaExpiradaParceiro && !ehEstornada),
                'beneficio--expirado':
                  (experienciaExpirada && tipo == 3) ||
                  (experienciaExpiradaParceiro && tipo == 3),
                'momento--utilizado':
                  experiencia.quantidadeDisponivel == 0 && !ehEstornada,
                'momento--disponivel':
                  experiencia.quantidadeDisponivel > 0 &&
                  (!experienciaExpirada || experienciaExpiradaParceiro)
              }"
              *ngIf="
                (statusBeneficioEexpirado ||
                  statusExpirado ||
                  statusEstornado ||
                  statusUtilizado ||
                  statusDisponivel) &&
                parceiroViva
              "
            >
              <img
                class="icon__status"
                [src]="this.iconeStatus"
                alt="Ícone do status"
              />
              {{ textoStatus }}
            </p>
            <p
              class="experiencia__nome"
              [ngClass]="{ 'nome--extenso': nome.length > 50 }"
            >
              {{ nome }}
            </p>
          </div>
          <div
            class="button__expandir"
            [ngClass]="{
              posicao__button: windowWidth > 999,
              correcao__posicao: onClickExpandir
            }"
            *ngIf="windowWidth > 999"
          >
            <button class="button" (click)="expandirCard()">
              <img class="img__expandir" [src]="iconeExpandirSrc()" alt="" />
              <span class="texto-hover"
                >{{
                  !onClickExpandir ? "Mais informações" : "Menos informações"
                }}
              </span>
            </button>
          </div>
        </div>
        <div
          class="id_resgate"
          [ngClass]="{
            correcao__posicao__id: onClickExpandir,
            correcao__sem__tag: !textoStatus
          }"
        >
          <p class="resgate__tittle">ID do Resgate</p>
          <p class="resgate__data">
            {{ idExperienciaMembro }}
          </p>
          <p *ngFor="let id of idsExperienciaMembro" class="id__numero">
            {{ id }}
          </p>
        </div>
        <div class="experiencia__footer">
          <div class="experiencia__valor__unidades" *ngIf="tipo != 3">
            <div class="valores">
              <p class="cacaus">
                <img
                  class="cacaus__icone"
                  src="assets/images/icons/cacau_moeda.png"
                />
                {{ cacaus }} {{ cacaus > 1 ? "Cacaus" : "Cacau" }}
              </p>
              <p class="unidades">
                <img
                  class="unidades__icone"
                  src="assets/images/icons/ticket.svg"
                />
                {{ unidades }} {{ unidades > 1 ? "Unidades" : "Unidade" }}
              </p>
            </div>
            <div
              class="mapa"
              [ngClass]="{ location: onClickExpandir }"
              *ngIf="windowWidth > 999"
            >
              <p class="informacoes clicavel" (click)="abrirMapa()">
                <img
                  class="mapa__icone"
                  src="assets/images/icons/location__point.png"
                />
                {{ nomeLocal }}Locais disponiveis
              </p>
            </div>
          </div>
          <div
            class="promocao__com__validade"
            [ngClass]="{ 'com--validade': experiencia?.prazoEmDias == 0 }"
            *ngIf="tipo == 3"
          >
            <div
              class="resgate"
              *ngIf="dataResgate !== undefined && !onClickExpandir"
            >
              <p class="resgate__tittle">Resgate</p>
              <p class="resgate__data">
                {{ dataResgate | date : "dd/MM/yyyy" }}
              </p>
            </div>
            <div
              class="mensagem__validade"
              *ngIf="
                experiencia?.prazoEmDias == 0 &&
                experiencia?.prazoEmData == null &&
                mensagemValidade !== null &&
                mensagemValidade !== '' &&
                !onClickExpandir
              "
            >
              <p class="msg__validade__tittle">Validade</p>
              <p class="msg__validade">
                {{ mensagemValidade }}
              </p>
            </div>
            <div
              class="vencimento"
              *ngIf="
                dataValidade !== undefined &&
                experiencia?.prazoEmDias > 0 &&
                !onClickExpandir
              "
            >
              <p class="vencimento__tittle">Vencimento</p>
              <p class="vencimento__data">
                {{ dataValidade | date : "dd/MM/yyyy" }}
              </p>
            </div>
            <div
              class="mapa"
              [ngClass]="{ location: onClickExpandir }"
              *ngIf="windowWidth > 999"
            >
              <p class="informacoes clicavel" (click)="abrirMapa()">
                <img
                  class="mapa__icone"
                  src="assets/images/icons/location__point.png"
                />
                {{ nomeLocal }}Locais disponiveis
              </p>
            </div>
          </div>
          <div class="validades" *ngIf="!onClickExpandir && tipo != 3">
            <div class="resgate" *ngIf="dataResgate !== undefined">
              <p class="resgate__tittle">Resgate</p>
              <p class="resgate__data">
                {{ dataResgate | date : "dd/MM/yyyy" }}
              </p>
            </div>
            <div
              class="mensagem__validade"
              *ngIf="
                experiencia?.prazoEmDias == 0 &&
                experiencia?.prazoEmData == null &&
                mensagemValidade !== null &&
                mensagemValidade !== '' &&
                !onClickExpandir
              "
            >
              <p class="msg__validade__tittle">Validade</p>
              <p class="msg__validade">
                {{ mensagemValidade }}
              </p>
            </div>
            <div
              class="vencimento"
              *ngIf="
                dataValidade !== undefined &&
                experiencia?.prazoEmDias > 0 &&
                !parceiroViva
              "
            >
              <p class="vencimento__tittle">Vencimento</p>
              <p class="vencimento__data">
                {{ dataValidade | date : "dd/MM/yyyy" }}
              </p>
            </div>
            <div
              class="vencimento"
              *ngIf="
                dataValidade !== undefined &&
                experiencia?.prazoEmDias > 0 &&
                parceiroViva
              "
            >
              <p class="vencimento__tittle">Vencimento</p>
              <p class="vencimento__data">
                {{ parceiroViva.ExpirationDate | date : "dd/MM/yyyy" }}
              </p>
            </div>
            <div
              class="vencimento"
              *ngIf="
                dataValidade !== undefined &&
                experiencia?.prazoEmDias == 0 &&
                experiencia?.prazoEmData != null &&
                !parceiroViva
              "
            >
              <p class="vencimento__tittle">Vencimento</p>
              <p class="vencimento__data">
                {{ dataValidade | date : "dd/MM/yyyy" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="parceiro__area" *ngIf="onClickExpandir">
      <div class="info__parceiro">
        <div class="com__parceiro" *ngIf="parceiroViva">
          <img
            src="../../../../../assets/images/icons/info_exp.svg"
            alt="Ícone de informação"
          />
          <p>{{ shortDescription }}</p>
        </div>
        <div class="resgate" *ngIf="tipo == 1">
          <img
            src="../../../../../assets/images/icons/resgate__fisico.svg"
            alt="Ícone de loja"
          />
          <p>Resgate no caixa da loja</p>
        </div>
        <div class="resgate" *ngIf="acompanhantes != '' && acompanhantes">
          <img
            src="../../../../../assets/images/icons/acompanhantes.svg"
            alt="Ícone de acompanhante"
          />
          <p>
            {{
              retornaAcompanhantes() > 1
                ? retornaAcompanhantes() + " Acompanhantes"
                : retornaAcompanhantes() +
                  "
            Acompanhante"
            }}
          </p>
        </div>
        <div class="resgate" *ngIf="dataEvento != null">
          <img
            src="../../../../../assets/images/icons/calendar__parc.svg"
            alt="Ícone de acompanhante"
          />
          <p>{{ retornaDataFormatada() }}</p>
        </div>
        <div class="parceiro">
          <img
            src="../../../../../assets/images/icons/verificado.svg"
            alt="Ícone verificado"
          />
          <p>
            {{ parceiroNome }}
          </p>
        </div>
        <div class="parceiro" *ngIf="parceiroViva?.Redirect">
          <img
            src="../../../../../assets/images/icons/verificado.svg"
            alt="Ícone verificado"
          />
          <a [href]="parceiroViva.Redirect" target="_blank">Link</a>
        </div>

      </div>
    </div>
    <div
      class="mecanica"
      *ngIf="onClickExpandir"
      [ngClass]="{
        experiencia__integracao: parceiroViva,
        border__bottom: windowWidth > 999 && experiencia?.cupons.length > 0
      }"
    >
      <div
        class="mapa"
        [ngClass]="{ location: onClickExpandir }"
        *ngIf="windowWidth <= 999"
      >
        <p class="informacoes clicavel" (click)="abrirMapa()">
          <img
            class="mapa__icone"
            src="assets/images/icons/location__point.png"
          />
          {{ nomeLocal }}Locais disponiveis
        </p>
      </div>
      <!-- <div
        class="mecanica__parceiro"
        *ngIf="parceiroViva"
        [innerHTML]="parceiroViva.product_data.info.validation_message"
      ></div> -->
      <div class="mecanica__resgate" *ngIf="!parceiroViva">
        <p class="mecanica__tittle">Mecânica de Resgate</p>
        <div class="container__topicos">
          <div class="topico">
            <div
              class="lista__topicos"
              *ngFor="
                let descricaoValor of mecanicaResgate;
                let i = index;
                let l = last
              "
            >
              <div class="descricao">
                <p class="numero__topico">{{ i + 1 }}.</p>
                <p class="texto__topico">
                  {{ descricaoValor }}
                </p>
              </div>
              <div class="barra__topico" *ngIf="!l"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="observacao"
        *ngIf="experiencia.detalhamentoMomentoEspecial && !parceiroViva"
      >
        <div class="tittle">
          <img
            src="../../../../../assets/images/icons/alert.svg"
            alt="Alerta"
          />
          <p class="obs__tittle">Outras observações</p>
        </div>
        <div *ngFor="let texto of observacoes">
          <p class="texto__titulo">{{ texto.titulo }}</p>

          <div *ngFor="let descricao of texto.experienciaParagrafo">
            <ul class="texto__topico">
              <li>{{ descricao.descricao }}</li>
            </ul>
          </div>
        </div>
        <div *ngIf="existeDetalhamentoMomentoEspecial">
          <div
            class="obervacao__texto"
            [innerHtml]="experiencia.detalhamentoMomentoEspecial | linkify"
          ></div>
        </div>
      </div>
      <div
        class="resgate__vencimento"
        [ngClass]="{
          'ajuste--coluna':
            experiencia?.prazoEmDias == 0 &&
            (mensagemValidade != '' || mensagemValidade != null) &&
            !parceiroViva &&
            windowWidth <= 999
        }"
      >
        <div
          class="data__resgate"
          *ngIf="!parceiroViva"
          [ngClass]="{
            preenche__espaco:
              windowWidth <= 999 && experiencia?.prazoEmDias == 0
          }"
        >
          <p class="data__tittle">Resgate</p>
          <p class="data" *ngIf="dataResgate !== undefined">
            {{ dataResgate | date : "dd/MM/yyyy" }}
          </p>
        </div>
        <div
          class="data__resgate"
          [ngClass]="{
            preenche__espaco:
              windowWidth <= 999 && experiencia?.prazoEmDias == 0
          }"
          *ngIf="
            !parceiroViva &&
            (mensagemValidade == null || mensagemValidade == '')
          "
        >
          <p class="data__tittle">Vencimento</p>
          <p class="data" *ngIf="dataValidade !== undefined">
            {{ dataValidade | date : "dd/MM/yyyy" }}
          </p>
        </div>
        <div
          class="data__resgate"
          [ngClass]="{
            preenche__espaco:
              windowWidth <= 999 && experiencia?.prazoEmDias == 0
          }"
          *ngIf="
            !parceiroViva &&
            experiencia?.prazoEmDias == 0 &&
            experiencia?.prazoEmData != null
          "
        >
          <p class="data__tittle">Vencimento</p>
          <p class="data" *ngIf="dataValidade !== undefined">
            {{ dataValidade | date : "dd/MM/yyyy" }}
          </p>
        </div>
        <div
          class="data__resgate__validade"
          [ngClass]="{
            preenche__espaco:
              windowWidth <= 999 && experiencia?.prazoEmDias == 0
          }"
          *ngIf="
            mensagemValidade != null &&
            !parceiroViva &&
            mensagemValidade != '' &&
            experiencia?.prazoEmData == null
          "
        >
          <p class="data__tittle">Validade</p>
          <p class="msg__validade">
            {{ mensagemValidade }}
          </p>
        </div>
        <div class="resgate__vencimento__parceiro" *ngIf="parceiroViva">
          <div class="res__ven">
            <div
              class="data__resgate"
              [ngClass]="{
                preenche__espaco:
                  windowWidth <= 999 && experiencia?.prazoEmDias == 0
              }"
            >
              <p class="data__tittle">Resgate</p>
              <p class="data" *ngIf="dataResgate !== undefined">
                {{ dataResgate | date : "dd/MM/yyyy" }}
              </p>
            </div>
            <div
              class="data__resgate"
              [ngClass]="{
                preenche__espaco:
                  windowWidth <= 999 && experiencia?.prazoEmDias == 0
              }"
            >
              <p class="data__tittle">Vencimento</p>
              <p class="data" *ngIf="parceiroViva.ExpirationDate !== undefined">
                {{ parceiroViva.ExpirationDate | date : "dd/MM/yyyy" }}
              </p>
            </div>
          </div>
          <div class="cod__resgate__seguranca" *ngIf="parceiroViva?.Code">
            <div class="cod__resgate">
              <p class="cod__resgate__tittle">Código de resgate</p>
              <p class="codigo">
                {{ parceiroViva?.Code }}
              </p>
            </div>
          </div>
          <!-- <div
            class="cod__resgate__seguranca"
            *ngFor="let codigoRes of parceiroViva.codes; let i = index"
          >
            <div class="cod__resgate">
              <p class="cod__resgate__tittle">Código de resgate</p>
              <p class="codigo">
                {{ codigoRes }}
              </p>
            </div>
            <div class="cod__seguranca">
              <p class="cod__seguranca__tittle">Código de segurança</p>
              <p class="codigo__seg">
                {{ parceiroViva.verificationCodes[i] }}
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="resgate__cupom" *ngIf="onClickExpandir && !parceiroViva">
      <div class="efeito__bilhete" *ngIf="windowWidth <= 999">
        <div class="circle"></div>
        <svg
          width="297"
          height="1"
          viewBox="0 0 297 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 0.5L296 0.50003"
            stroke="#D7C0BC"
            stroke-linecap="round"
            stroke-dasharray="8 8"
          />
        </svg>
        <div class="circle2"></div>
      </div>
      <div class="id__resgate" *ngIf="existePromocoesUsuarios">
        <p class="id__tittle">ID do Resgate</p>
        <div class="ids__resgate">
          <p class="id__numero">{{ idExperienciaMembro }}</p>
          <p *ngFor="let id of idsExperienciaMembro" class="id__numero">
            {{ id }}
          </p>
        </div>
      </div>
      <div class="cupom" *ngIf="experiencia?.cupons.length > 0">
        <p class="cupom__tittle">Cupom</p>
        <div class="cupons">
          <p *ngFor="let cupom of experiencia.cupons" class="cupom__cod">
            {{ cupom }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
